const EVENT_NAME = 'ExploreLearningJourney';

export default function track(location: string, clickEvent: string, target: any) {
  GustoAnalytics.track({
    eventCategory: EVENT_NAME,
    eventName: clickEvent,
    data: {
      location,
      target,
    },
  });
}
